export const LD_IDENTIFY_TIMEOUT_MS = 5000

export const identifyLaunchDarklyWithTimeout = async (
  identify: () => Promise<unknown>,
  timeoutMs = LD_IDENTIFY_TIMEOUT_MS,
): Promise<void> => {
  let timeoutId: ReturnType<typeof setTimeout> | undefined
  const timeout = new Promise<never>((_, reject) => {
    timeoutId = setTimeout(() => reject(new Error('LaunchDarkly identify timed out')), timeoutMs)
  })

  try {
    await Promise.race([identify(), timeout])
  } finally {
    if (timeoutId !== undefined) {
      clearTimeout(timeoutId)
    }
  }
}
